import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import adminReducer from './admin'
import blogReducer from './blog'
import newsReducer from './news'
import jobsReducer from './jobs'
import eventsReducer from './events'
import subscribeReducer from './subscribe'
import contactReducer from './contactenquiry'
import resumeReducer from './cv'



export default configureStore({
  reducer: {

    auth:authReducer,
    admin:adminReducer,
    blog:blogReducer,
    news:newsReducer,
    jobs:jobsReducer,
    events:eventsReducer,
    subscribe:subscribeReducer,
    contactEnquiry:contactReducer,
    resume:resumeReducer


  },
});
